import { useIntl } from 'react-intl'

import type { TagOverflowProps } from './TagOverflow.types'

export const TagOverflow = (props: TagOverflowProps) => {
  const { count, onClick } = props
  const intl = useIntl()

  if (count <= 0) {
    return null
  }

  // Read-only surfaces pass no click action: render the same "+N" visual as
  // plain text instead of a button nothing can activate.
  if (!onClick) {
    return (
      <span className="TagBadge TagBadge--overflow TagBadge--overflowStatic">
        +{count}
      </span>
    )
  }

  return (
    <button
      aria-label={intl.formatMessage({ id: 'Tags_show_more' }, { count })}
      className="TagBadge TagBadge--overflow"
      onClick={onClick}
      type="button"
    >
      +{count}
    </button>
  )
}
